// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"uploadProgress_wrapper__2ej-Z","closeButton":"uploadProgress_closeButton__Z4dwC"};